export default {"src":"/_next/static/media/CarCloud-White-Logo-2.d4b90dd0.svg","height":55,"width":304};